import { AppHealthPage } from './AppHealthPage'

export const ChatAIPlus = () => {
  return <AppHealthPage appName="chataiplus" displayName="ChatAI Plus" />
}

export default ChatAIPlus
